import { Route, Routes, useLocation } from "react-router-dom";
import Layout from "./components/Layout";
import Layout2 from "./components/Layout/Layout2";
import Layout3 from "./components/Layout/Layout3";
import Layout4 from "./components/Layout/Layout4";
import Home from "./components/Pages/Home";
import HomeStyle2 from "./components/Pages/HomeStyle2";
import HomeStyle3 from "./components/Pages/HomeStyle3";
import HomeStyle4 from "./components/Pages/HomeStyle4";
import About from "./components/Pages/About";
import Dokter from "./components/Pages/Doctors";
import Blog from "./components/Pages/Blog";
import Appointments from "./components/Pages/Pendaftaran";
import Layanan from "./components/Pages/Layanan";
import IGD from "./components/Pages/layanan/Igd";
import Laboratorium from "./components/Pages/layanan/Laboratorium";
import BlogDetails from "./components/Pages/BlogDetails";
import DoctorDetails from "./components/Pages/DoctorDetails";
import PricingPlan from "./components/Pages/PricingPlan";
import Gallery from "./components/Pages/Gallery";
import Contact from "./components/Pages/Contact";
import { useEffect } from "react";
import ErrorPage from "./components/Pages/ErrorPage";
import Layout5 from "./components/Layout/Layout5";
import HomeStyle5 from "./components/Pages/HomeStyle5";
import HomeStyle6 from "./components/Pages/HomeStyle6";
import Poliklinik from "./components/Pages/layanan/Poliklinik";
import MedicalCheckUp from "./components/Pages/layanan/Mcu";
import Fisioterapi from "./components/Pages/layanan/Fisioterapi";
import RawatInap from "./components/Pages/layanan/RawatInap";
import Farmasi from "./components/Pages/layanan/Farmasi";
import RuangOperasi from "./components/Pages/layanan/RuangOperasi";
import Pendaftaran from "./components/Pages/Pendaftaran";
import Jadwaldokter from "./components/Pages/JadwalDokter";

function App() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="about" element={<About />} />
        <Route path="dokter" element={<Dokter />} />
        <Route path="doctors/:doctorId" element={<DoctorDetails />} />
        <Route path="blog" element={<Blog />} />
        <Route path="blog/:blogId" element={<BlogDetails />} />
        <Route path="appointments" element={<Appointments />} />
        <Route path="layanan" element={<Layanan />} />
        <Route path="IGD" element={<IGD />} />
        <Route path="laboratorium" element={<Laboratorium />} />
        <Route path="poliklinik" element={<Poliklinik />} />
        <Route path="medicalcheckUp" element={<MedicalCheckUp />} />
        <Route path="fisioterapi" element={<Fisioterapi />} />
        <Route path="rawatinap" element={<RawatInap />} />
        <Route path="farmasi" element={<Farmasi />} />
        <Route path="Ruangoperasi" element={<RuangOperasi />} />
        <Route path="pricing-plan" element={<PricingPlan />} />
        <Route path="gallery" element={<Gallery />} />
        <Route path="pendaftaran" element={<Pendaftaran />} />
        <Route path="jadwaldokter" element={<Jadwaldokter />} />
        <Route path="contact" element={<Contact />} />
      </Route>
      <Route element={<Layout2 />}>
        <Route path="home-v2" element={<HomeStyle2 />} />
        <Route path="home-v6" element={<HomeStyle6 />} />
      </Route>
      <Route path="home-v3" element={<Layout3 />}>
        <Route index element={<HomeStyle3 />} />
      </Route>
      <Route path="home-v4" element={<Layout4 />}>
        <Route index element={<HomeStyle4 />} />
      </Route>
      <Route path="home-v5" element={<Layout5 />}>
        <Route index element={<HomeStyle5 />} />
      </Route>
      <Route path="*" element={<ErrorPage />} />
    </Routes>
  );
}

export default App;
